import fetch from 'unfetch';

function calculateEndpoint(hostname = window.location.hostname) {
  let endpoint = 'https://x.clearbit.com';

  const localDevelopment = 'localhost' === hostname;
  const webLocal = 'web.local' === hostname;
  const xBranch = /^clearbit-x-pr-\d+\.dev\.clearbit\.io$/.test(hostname);
  if (localDevelopment || webLocal || xBranch) {
    return '';
  }

  const development = /dev\.clearbit\.io$/.test(hostname);
  if (development) {
    return 'https://clearbit-x.dev.clearbit.io';
  }

  const staging = /staging\.clearbit\.io$/.test(hostname);
  if (staging) {
    return 'https://clearbit-x.staging.clearbit.io';
  }

  return endpoint;
}

const endpoint = calculateEndpoint();

function queryParams(params) {
  return Object.keys(params)
    .map(
      (key) => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]),
    )
    .join('&');
}

function request(options) {
  let url = endpoint + options.path;

  return fetch(url, {
    method: options.type,
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(options.json),
  })
    .then((response) => {
      if (response.ok) {
        if (response.status === 204) {
          // Our DELETE routes often return an empty body, which causes
          // response.json() to throw an error
          return Promise.resolve({ status: 'ok' });
        }
        return response.json();
      } else {
        return response.json().then((json) => {
          json.response = response;
          json.status = response.status;
          return Promise.reject(json);
        });
      }
    })
    .then((json) => {
      if (json.error) {
        return Promise.reject(json);
      }

      return json;
    });
}

export default request;
export { calculateEndpoint, endpoint, queryParams };
